{
  "validation.required": "{{label}} är ett obligatoriskt fält",
  "validation.minLength": "{{label}} måste vara minst {{min}} tecken lång",
  "validation.maxLength": "{{label}} kan inte vara längre än {{max}} tecken",
  "validation.contentTypeAlphanumeric": "{{label}} måste vara alfanumerisk",
  "validation.contentTypeDate": "{{label}} måste vara ett datum",
  "validation.contentTypeDateBefore": "{{label}} måste vara ett datum före {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} måste vara ett datum efter {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} måste vara ett datum och en tid",
  "validation.contentTypeDatetimeBefore": "{{label}} måste vara ett datum före {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} måste vara ett datum efter {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} måste vara ett e-postmeddelande",
  "validation.contentTypeInteger": "{{label}} måste vara ett tal",
  "validation.contentTypeNumber": "{{label}} måste vara ett nummer",
  "validation.contentTypeRegex": "{{label}} har fel format",
  "validation.contentTypeText": "{{label}} måste vara en text",
  "validation.contentTypeTime": "{{label}} måste vara en tid",
  "validation.contentTypeUrl": "{{label}} måste vara en webbadress",
  "select-element.default-option": "Välj…",
  "button-element.network-required": "Du är för närvarande offline. Vänligen upprätta en nätverksanslutning för att fortsätta."
}